export const resultStatusStyles = { display: 'flex', alignItems: 'center', gap: '8px' };

export const resultTextStyles = { display: 'flex', flexDirection: 'column', minWidth: 0 };
